import {  createSlice } from '@reduxjs/toolkit';
//import Config from '../../../config/config';

//const serverPath = Config.serverPath;

//INITIAL STATE BEGINNING

const initialState ={ 
    
    openDeleteContactsForm: false,
    openDeleteGroupContactsForm: false,
    openDeleteUserGroupContactsForm: false,
    openChangeNameGroupContactsForm: false,
    selectedContactId:'',
    selectedGroupContactId:'',
    openSendBox: false,
    shadeView: false,
    messageFindContact:'',
   

  
};



const options = {
    name: 'contatcs',
    initialState: {
        
       
        openDeleteContactsForm: false,
        openDeleteGroupContactsForm: false,
        openDeleteUserGroupContactsForm: false,
        openChangeNameGroupContactsForm: false,
        selectedContactId:'',
        selectedGroupContactId:'',
        openSendBox: false,
        shadeView: false,
        messageFindContact:'',
        
   
    },
    reducers: {
         // GET first INITIAL STATE
         getInitialStateContacts: state  => 
         initialState,
       
       
        openDeleteContactsForm: (state) => {
            state.openDeleteContactsForm = true;
        },
        closeDeleteContactsForm: (state) => {
            state.openDeleteContactsForm = false;
        },
        openDeleteGroupContactsForm: (state) => {
            state.openDeleteGroupContactsForm = true;
        },
        closeDeleteGroupContactsForm: (state) => {
            state.openDeleteGroupContactsForm = false;
        },
        openDeleteUserGroupContactsForm: (state) => {
            state.openDeleteUserGroupContactsForm = true;
        },
        closeDeleteUserGroupContactsForm: (state) => {
            state.openDeleteUserGroupContactsForm = false;
        },
        closeChangeNameContactsForm: (state) => {
            state.openChangeNameGroupContactsForm = false;
        },
        openChangeNameGroupContactsForm: (state) => {
            state.openChangeNameGroupContactsForm = true;
        },
       setSelectedContactId: (state, action) => {
        state.selectedContactId = action.payload;
       },
        setSelectedGroupContactId: (state, action) => {
        state.selectedGroupContactId = action.payload;
       },
       setOpenSendBox: (state) => {
        state.openSendBox = !state.openSendBox;
       },
       closeSendBox: (state) => {
        state.openSendBox = false;
       },
       onShadeView: (state) => {
        state.shadeView = !state.shadeView;
       },
        setMessageFindContact: (state, action) => {
        state.messageFindContact = 'в контактах';
       },
       
        clearMessageFindContact: (state, action) => {
        state.messageFindContact = '';
       },



    }, 
   
}
export const contactsSlice = createSlice(options);
export const { openDeleteContactsForm, getInitialStateContacts, closeDeleteContactsForm, 
    setSelectedContactId, setOpenSendBox, closeSendBox, onShadeView, openDeleteGroupContactsForm, 
    closeDeleteGroupContactsForm, setSelectedGroupContactId, closeChangeNameContactsForm,
     openChangeNameGroupContactsForm, setMessageFindContact, clearMessageFindContact, 
    openDeleteUserGroupContactsForm, closeDeleteUserGroupContactsForm} = contactsSlice.actions;
export default contactsSlice.reducer;